import _ from "lodash"
import moment from "moment"

export function storageValueWithTTL(key: string, value: string, ttl = 10) {
    localStorage.setItem(key, value)
    localStorage.setItem(key + '__expire_at', moment().add(ttl, 'seconds').format())
}

export function getStorageValueWithTTL(key: string) {
    const item = localStorage.getItem(key)
    if (_.isNil(item)) {
        return undefined
    }
    const expireTime = localStorage.getItem(key + '__expire_at')
    if (_.isNil(expireTime)) {
        return undefined
    }
    if (moment().isBefore(moment(expireTime))) {
        return item
    }
    return undefined
}


class LoginCounter {
    static key = '__login_counter'
    get() {
        try {
            let res = localStorage.getItem(LoginCounter.key)
            if (!res) {
                return 0
            }
            return _.toInteger(res)
        } catch {
            return 0
        }
    }
    incr() {
        let value = this.get()
        value += 1
        localStorage.setItem(LoginCounter.key, _.toString(value))
    }
    clear() {
        localStorage.removeItem(LoginCounter.key)
    }
}
export const loginCounter = new LoginCounter()